var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5839 2.2137C10.8648 3.17435 11.3486 7.10043 13.6645 10.9828C15.9804 14.8652 19.2515 17.2338 20.9706 16.2731C22.6898 15.3125 22.206 11.3864 19.89 7.50401C17.5741 3.6216 14.303 1.25305 12.5839 2.2137Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80847 5.17542L2.34288 15.409C1.9216 15.9865 1.88568 16.7484 2.25087 17.3606C2.61606 17.9728 3.3157 18.3236 4.04305 18.2592L6.41887 18.0489L6.60675 19.5299C6.80234 21.0717 8.25227 22.1681 9.84525 21.9787L11.6825 21.7604C13.2755 21.5711 14.4083 20.1678 14.2127 18.626L14.0538 17.3732L16.9794 17.1142C16.8056 17.0041 16.6348 16.8878 16.4676 16.7667C14.9133 15.6413 13.3719 13.8879 12.127 11.8008C10.8814 9.7128 10.0866 7.54905 9.85817 5.6952C9.83681 5.52189 9.82005 5.34841 9.80847 5.17542ZM8.36197 19.3213L8.18077 17.893L12.2919 17.5291L12.4575 18.8346C12.534 19.4381 12.0906 19.9875 11.467 20.0616L9.62974 20.2799C9.00614 20.3541 8.43854 19.9248 8.36197 19.3213Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone2);
export default __webpack_public_path__ + "static/media/megaphone-2.625a145a57e0696b87b6a05d7631f8da.svg";
export { ForwardRef as ReactComponent };